import { Carousel, CarouselCard } from "../Carousel";

export default function SectionFour() {
  return (
    <div className="w-full space-y-16">
      <div className="space-y-1 text-center">
        <h1 className="font-newsreader text-5xl leading-12 font-bold -tracking-wide text-neutral-950">
          One platform. Five media types.
        </h1>
        <p className="text-2xl leading-normal font-medium tracking-normal text-neutral-800">
          Most monitoring tools make you choose: social media or traditional.
          Metawhale gives you both.{" "}
        </p>
      </div>
      <div className="w-full">
        <Carousel className="noselect">
          <CarouselCard
            icon={
              <img
                src="/landing/newspaper.svg"
                alt="Print"
                className="noselect h-44 w-44"
                draggable={false}
              />
            }
            title="Print"
            description="Coverage of national newspapers, provincial papers, tabloids, business journals, and magazines across the Philippine print landscape."
            badge={
              <i className="ri-newspaper-fill text-md font-light text-neutral-500/50"></i>
            }
          />
          <CarouselCard
            icon={
              <img
                src="/landing/laptop.svg"
                alt="Online"
                className="h-44 w-44"
                draggable={false}
              />
            }
            title="Online"
            description="Monitor news websites, digital publications, blogs, and web platforms. Track breaking news and online discussions in real time."
            badge={
              <i className="ri-global-fill text-md font-light text-neutral-500/50"></i>
            }
          />
          <CarouselCard
            icon={
              <img
                src="/landing/tv.svg"
                alt="TV"
                className="h-44 w-44"
                draggable={false}
              />
            }
            title="TV"
            description="Track mentions across television networks, news programs, talk shows, and broadcast specials on primetime and morning shows."
            badge={
              <i className="ri-tv-fill text-md font-light text-neutral-500/50"></i>
            }
          />
          <CarouselCard
            icon={
              <img
                src="/landing/radio.svg"
                alt="Radio"
                className="h-44 w-44"
                draggable={false}
              />
            }
            title="Radio"
            description="Monitor AM and FM stations, news programs, and commentary shows across Metro Manila and provincial stations."
            badge={
              <i className="ri-radio-fill text-md font-light text-neutral-500/50"></i>
            }
          />
          <CarouselCard
            icon={
              <img
                src="/landing/social-media.svg"
                alt="Social Media"
                className="h-44 w-44"
                draggable={false}
              />
            }
            title="Social Media"
            description="Track conversations on Facebook, Instagram, X, TikTok, and YouTube. Monitor mentions, hashtags, and sentiment."
            badge={
              <i className="ri-facebook-fill text-md font-light text-neutral-500/50"></i>
            }
          />
        </Carousel>
      </div>{" "}
    </div>
  );
}
